import CashTamerHttpClient from './CashTamerHttpClient';
import CashTamerApiBase from './CashTamerApiBase';
import CreateUnverifiedMemberModel from '@/models/unverifiedmembers/CreateUnverifiedMemberRequestModel';
import ReissueVerificationTokenRequestModel from '@/models/unverifiedmembers/ReissueVerificationTokenRequestModel';
import VerifyRequestModel from '@/models/unverifiedmembers/VerifyRequestModel';

export default class UnverifiedMembersApi extends CashTamerApiBase {
    public async createAsync(request: CreateUnverifiedMemberModel): Promise<void> {

        try {
            const httpClient = new CashTamerHttpClient();

            const httpResponse = await httpClient.postAsync('unverifiedmembers', request);
        }
        catch (err) {
            return this.handleApiError(err);
        }
    }

    public async reissueVerificationTokenAsync(request: ReissueVerificationTokenRequestModel): Promise<void> {

        try {
            const httpClient = new CashTamerHttpClient();

            const httpResponse = await httpClient.postAsync('unverifiedmembers/reissueverificationtoken', request);
        }
        catch (err) {
            return this.handleApiError(err);
        }
    }

    public async verifyAsync(request: VerifyRequestModel): Promise<void> {

        try {
            const httpClient = new CashTamerHttpClient();

            const httpResponse = await httpClient.postAsync('unverifiedmembers/verify', request);
        }
        catch (err) {
            return this.handleApiError(err);
        }
    }
}
